import chatApi from '../chatApi';
import ChatService from './ChatService';

const chatService = new ChatService(chatApi);

export default chatService;
